import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { authInterceptor } from './shell/auth/auth.interceptor';
import { apiLoggingInterceptor } from './core/api-logging.interceptor';
import { routes } from './app.routes';
import { BASE_PATH } from '../sdk/core/variables';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withEnabledBlockingInitialNavigation()),
    provideHttpClient(withInterceptors([apiLoggingInterceptor, authInterceptor])),
    provideIonicAngular({ mode: 'ios' }),
    { provide: BASE_PATH, useValue: environment.apiUrl },
  ],
};
